import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

export default buildFacetDesignOverride()
  .typeOverride('picklist', {
    _customProps: {
      fullWidth: true,
    },
  })
  .nameOverride(['moduleName', 'pretitle', 'title', 'subtitle', 'primaryText', 'secondaryText', 'additionalDetailTitle', 'additionalDetailItems', 'attachmentButtonText'], {
    hidden: true,
  });
